<template>
    <section class="dash-card-graphic mb-20">
        <div class="header">
            <div class="text">
                Clientes
                <span v-if="filter && filter !== 'clear'">
                    - {{ filter }}
                </span>
                <span v-else>
                    - Todos
                </span>
            </div>
            <div class="filter">
                <label class="text-year">Ano:</label>
                <ui-select v-model="filter" inline size="sm">
                    <option
                        v-for="item in filtersData"
                        :key="item.id"
                        :value="item.id">
                        {{ item.text }}
                    </option>
                </ui-select>

            </div>
        </div>
        <ui-graphic-bars :load="load || reload" :data="data" :labels="labels" :h="186" />
    </section>
</template>

<script>
    import { uiGraphicBars} from '@/components/ui'
    import { uiSelect } from '@/components/ui/form'
    import { customer } from '@/services/axios'

    export default {
        name: 'dash-clients-graphic',

        components: { uiSelect, uiGraphicBars },

        data() {
            return {
                load: true,
                reload: false,
                filter: 'Todos',
                labels: [],
                data: [],
                filtersData: []
            }
        },
        computed: {
            dataFilter() {
                return this.filter
            },
            dataComputed: {
                get() {
                    return this.data
                },
                set(value) {
                    let data = value
                    const keys = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
                    const diff = keys.filter(x => !data.map(o => o.f).includes(x))
                    diff.forEach((item) => {
                        data.push({ f: item, v: 0 })
                    })
                    this.data = data.sort((a, b) => a.f - b.f)
                }
            }
        },

        watch: {
            dataFilter() {
                if (this.filter === 'clear') {
                    this.getData()
                } else {
                    this.getData(this.filter)
                }
            }
        },

        created() {
            this.getData()
            this.loadFilters()
        },

        methods: {
            getData(filter = null) {
                let params = {}
                if (filter) {
                    params.year = filter
                }

                this.reload = this.load ? false : true
                customer.getAll(
                    '/get-by-broker',
                    params
                ).then((response) => {
                    this.load   = false
                    this.reload = false
                    this.dataComputed = response.data.map((item) => {
                        item = { f: item.month, v: item.count }
                        return item
                    })

                    this.labels = [ 'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']

                }, error => {
                    console.log(error.response)
                })

            },
            loadFilters() {
                customer.readFilters()
                    .then((response) => {
                        this.filtersData = response.data
                    })
                    .catch((error) => {
                        console.log(error.response)
                    })
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
